module.exports = __webpack_public_path__ + "static/img/geralt.b0adb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/geralt.png
// module id = kQCg
// module chunks = 0